cb.define(['common/common_VM.Extend.js'], function (common) {
  //String转换Int（位运算）
  var setCheckBoxEnum = function (data) {

    if (data != undefined) {
      var oldData = data.split(",");
      var result = 0;
      if (oldData != "") {
        oldData.forEach(function (item, index) {
          result += Math.pow(2, parseInt(item) - 1);
        });
      }
      return result;
    } else {
      return 0;
    }

  };

  var PM_pmc_productcardcoupon_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },

    init: function (viewmodel) {
      let mode = viewmodel.getParams().mode;
      var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');

      viewmodel.on('afterLoadData', function (data) {
        common.displayArea(viewmodel);
        common.displayChannel(viewmodel, 'productcardcoupon');
        let auditStatusModel = viewmodel.get('applicableChannel');
        if (auditStatusModel) {
          let dataSource = auditStatusModel.getState('dataSource');
          let newSource = [];
          dataSource && dataSource.forEach(data => {
            //丢弃线下零售
            if (data.value != "1") {
              newSource.push({value: data.value, nameType: 'text', text: data.text});
            }
          });
          auditStatusModel.setDataSource(newSource);
        }
        viewmodel.get('applicableChannel').setDisabled(true);
        viewmodel.get('bMemberLevelAll').setDisabled(true);
        viewmodel.get('terminalType').setDisabled(true);
        if (this.get('applyOnlineChannel').getValue() == false) {
          viewmodel.get("terminalType").setVisible(false);
        } else {
          viewmodel.get("terminalType").setVisible(true);
          viewmodel.get('applicableChannel').setValue(["0"]);
        }
        if (this.get('bMemberLevelAll').getValue() == 0) {
          viewmodel.get('productCardCouponMemberL').setVisible(true);
        } else {
          viewmodel.get('productCardCouponMemberL').setVisible(false);
        }
        // 0 商品  1 商品分类
        if (viewmodel.get('actityItemType').getValue() == 0) {
          let fieldmap = {};
          fieldmap.iReferenceName = false;
          displayField(fieldmap);
        } else {
          let fieldmap = {};
          fieldmap.sProductName = false;
          fieldmap.sProductCode = false;
          fieldmap.sProductPicUrl = false;
          fieldmap.cDescribe = false;
          fieldmap.dPrice = false;
          displayField(fieldmap);
          viewmodel.get('btnImport').setVisible(false);
          viewmodel.get('btnExport').setVisible(false);
        }

        if (this.getParams().mode === 'add'||this.getParams().mode === 'edit') {
          viewmodel.get('btnDelete').setVisible(false);
          viewmodel.get('btnMoveprev').setVisible(false);
          viewmodel.get('btnMovenext').setVisible(false);
          viewmodel.get('btnAbandonBrowst').setVisible(false);
        } else{
          viewmodel.get('btnSave').setVisible(false);
          viewmodel.get('btnSaveAndAdd').setVisible(false);
          viewmodel.get('btnAbandon').setVisible(false);
          viewmodel.get('btnBatchOp').setVisible(false);
          viewmodel.get('btnProDelete').setVisible(false);
          viewmodel.get('btnAddRow').setVisible(false);
          viewmodel.get('btnBatchOp1').setVisible(false);
          viewmodel.get('btnProDelete1').setVisible(false);
          viewmodel.get('btnAddRow1').setVisible(false);
          displayForbidden(viewmodel);
        }
      });

      const displayForbidden = (viewmodel) => {
        let gridModel = viewmodel.getGridModel();
        let prorows = viewmodel.get('productCardCouponPro').getRows();
        let entityrows = viewmodel.get('productCardCouponEntity').getRows();
        let actionsStates = [];
        prorows.forEach(data => {
          let actionState = {};
          actionState["btnDeleteRow"] = {visible: false};
          actionsStates.push(actionState);
        });
        entityrows.forEach(data => {
          let actionState = {};
          actionState["btnDeleteRow1"] = {visible: false};
          actionsStates.push(actionState);
        });
        gridModel.setActionsState(actionsStates);
      }




      //适用渠道控制事件
      viewmodel.get('applicableChannel').on('afterValueChange', function (data) {
        if(data.value.length>0){
          viewmodel.get('terminalType').setVisible(true);
          viewmodel.get('applyOnlineChannel').setValue(true);
        }else{
          viewmodel.get('terminalType').setVisible(false);
          viewmodel.get('applyOnlineChannel').setValue(false);
        }
      });
      //买家范围控制事件
      viewmodel.get('bMemberLevelAll').on('afterValueChange', function (data) {
        if (data.value.value === '0') {
          viewmodel.get("productCardCouponMemberL").setVisible(true);
        } else {
          viewmodel.get('productCardCouponMemberL').setVisible(false);
        }
      });

      //商品类型变更事件及选取商品显示价格
      const delPro = () => {
        if (viewmodel.get('productCardCouponPro').getRows() && viewmodel.get('productCardCouponPro').getRows().length > 0) {
          let pricenums = viewmodel.get('productCardCouponPro').getRowsCount();
          for (let i = pricenums - 1; i >= 0; i--) {
            viewmodel.get('productCardCouponPro').deleteRows(i);
          }
        }
      }
      const displayField = (fieldmap) => {
        for (var key in fieldmap) {
          viewmodel.get("productCardCouponPro").setColumnState(key, "bShowIt", fieldmap[key]);
        }
      }

      const displayiAreaId = (viewmodel) => {
        if (viewmodel.get('actityItemType').getValue() == 0) {
          delPro();
        }
        let iRange = viewmodel.get("iRange").getValue();
        //平台
        if (iRange == 0) {
          viewmodel.get('btnImport').setVisible(true);
          viewmodel.get('btnExport').setVisible(true);
          viewmodel.get("iAreaId").setVisible(false);
          viewmodel.get("iAreaId").setValue(null);
        } else {
          viewmodel.get("iAreaId").setVisible(true);
          viewmodel.get('btnImport').setVisible(false);
          viewmodel.get('btnExport').setVisible(false);
        }
      }
      viewmodel.get('productCardCouponPro').on('afterCellValueChange', function (data){
        if (viewmodel.get('actityItemType').getValue() == 0) {
          this.setCellValue(data.rowIndex, 'iProductType', 0);
        }else{
          this.setCellValue(data.rowIndex, 'iProductType', 2);
        }
      });
      viewmodel.get('actityItemType').on('afterValueChange', function (data) {
        // 0 商品  1 商品分类
        delPro();
        let fieldmap = {};
        if (data.value.value === '0') {
          fieldmap.iReferenceName = false;
          fieldmap.sProductName = true;
          fieldmap.sProductCode = true;
          fieldmap.sProductPicUrl = true;
          fieldmap.cDescribe = true;
          fieldmap.dPrice = true;
          displayField(fieldmap);
          viewmodel.get('btnImport').setVisible(true);
          viewmodel.get('btnExport').setVisible(true);
        } else {
          fieldmap.iReferenceName = true;
          fieldmap.sProductName = false;
          fieldmap.sProductCode = false;
          fieldmap.sProductPicUrl = false;
          fieldmap.cDescribe = false;
          fieldmap.dPrice = false;
          displayField(fieldmap);
          viewmodel.get('btnImport').setVisible(false);
          viewmodel.get('btnExport').setVisible(false);
        }
      });

      viewmodel.get('productCardCouponEntity').on('beforeInsertRow', function (data) {
            var rows = viewmodel.get('productCardCouponEntity').getRows();
            if(rows!=''&&rows.length>=10){
              cb.utils.alert('优惠券最多设置10张！', 'warning');
              return false;
            }
        });

      //模板下载
      viewmodel.on('statictempexport', function (params) {
        const openUrl = params && params.cSvcUrl;
        if (!openUrl) {
          cb.utils.alert('导出模板的地址为空', 'error');
          return;
        }
        window.open(openUrl);
      });

      //导入
      viewmodel.on('batchimport', function (params) {
        const url = `${params.cSvcUrl}?token=${cb.rest.AppContext.token}&billnum=pmc_productcardcoupon`;
        const eleInput = document.createElement('input');
        eleInput.type = 'file';
        eleInput.style.display = 'none';
        eleInput.onchange = function (e) {
          const formData = new FormData();
          formData['enctype'] = 'multipart/form-data';
          formData.append('file', e.target.files[0]);

          var param = {};
          param.type = 1;
          param.applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
          param.applyOffLineChannel = 0;
          formData.append('data', JSON.stringify(param));

          cb.utils.alert(`导入中，请稍后`, 'info');

          const xhr = new XMLHttpRequest();
          xhr.open('POST', url, true);
          xhr.send(formData);
          xhr.onreadystatechange = function () {
            if (xhr.readyState !== 4) return;
            if (xhr.status === 200) {
              var ajaxResult = JSON.parse(xhr.responseText);
              if (ajaxResult.code === 200) {
                if (ajaxResult.data.code === 200) {
                  var array = [];
                  var res = ajaxResult.data.data;
                  var gridModel = viewmodel.get("productCardCouponPro");
                  for (let i = 0; i < res.data.length; i++) {
                    var appendData = {};
                    var data = res.data[i];
                    appendData.iProductType = data.iProductType;
                    appendData.sProductCode = data.cCode;
                    appendData.sProductName = data.sProductName;
                    appendData.dPrice = data.dPrice;
                    appendData.lProductId = data.lProductId;
                    appendData.sProductPicUrl = data.sProductPicUrl;
                    array.push(appendData);
                    // gridModel.appendRow(appendData);
                  }
                  let count = gridModel.getRowsCount();
                  var indexes = [];
                  for (let i = count - 1; i >= 0; i--) {
                    indexes.push(i);
                  }
                  gridModel.deleteRows(indexes);
                  gridModel.insertRows(0, array);
                  var errorMessages = '';
                  if (res.errorCount) {
                    for (let i = 0; i < res.allMsgs.length; i++) {
                      if (res.allMsgs[i].isError) {
                        errorMessages += res.allMsgs[i].msg;
                      }
                    }
                  }
                  cb.utils.alert(`共导入${res.totalCount}条, 成功${res.successCount}条, 失败${res.errorCount}条${res.errorCount ? `失败原因是: ${errorMessages}` : ''}`, res.errorCount ? 'error' : 'success');
                } else {
                  cb.utils.alert(`${ajaxResult.data.message}，模板内容导入失败`, 'error');
                }
              } else {
                cb.utils.alert(`${ajaxResult.message}，模板内容导入失败`, 'error');
              }
            }
          };
          document.body.removeChild(eleInput);
        };
        document.body.appendChild(eleInput);
        eleInput.click();
      });
      //清除全部商品
      viewmodel.on('batchProDelete', function (args) {
        delPro();
      })
      //清楚全部优惠券
      viewmodel.on('batchCouponDelete', function (args) {
        if (viewmodel.get('productCardCouponEntity').getRows() && viewmodel.get('productCardCouponEntity').getRows().length > 0) {
          let entitynums = viewmodel.get('productCardCouponEntity').getRowsCount();
          for (let i = entitynums - 1; i >= 0; i--) {
            viewmodel.get('productCardCouponEntity').deleteRows(i);
          }
        }
      })

      /**点击按钮弹出参照前事件
       *返回true则继续进行弹出参照操作，返回false则终止弹出
       */
      viewmodel.get("bMemberLevelAll").on('beforeBrowse', function () {
        return true;
      });

      viewmodel.get('productCardCouponPro').on('beforeBrowse', function (data) {
        if (data.cellName != 'iReferenceName') {

          let areaId;
          if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
            if (!viewmodel.get("iAreaId").getValue()) {
              cb.utils.alert('请选择适用区域', 'warning');
              return false;
            } else {
              areaId = viewmodel.get("iAreaId").getValue();
            }
          }
          common.productReferBrowseSimple(viewmodel, data, null, "productCardCouponPro", null, areaId);
          return true;
        } else {
          let classId = viewmodel.get('productCardCouponPro').getCellValue(data.rowIndex, 'lProductId');
          let condition = {
            "isExtend": true,
            simpleVOs: []
          };

          if (classId && classId != '') {
            condition.simpleVOs.push({
              field: 'id',
              op: 'eq',
              value1: classId
            });
          } else {
            let exitIds = [];
            let proClassList = viewmodel.get('productCardCouponPro').getRows();
            for (let i = 0; i < proClassList.length; i++) {
              let proClass = proClassList[i];
              if (proClass.lProductId) {
                exitIds.push(proClass.lProductId);
              }
            }
            if (exitIds && exitIds.length > 0) {
              condition.simpleVOs.push({
                field: 'id',
                op: 'nin',
                value1: exitIds
              });
            }
          }
          data.context.setTreeFilter(condition);
        }
      });

      viewmodel.get('productCardCouponEntity').on('beforeBrowse', function (data) {
        let condition = {
          "isExtend": true,
          simpleVOs: []
        };
        let exitIds = "";
        let couponList = viewmodel.get('productCardCouponEntity').getRows();
        for (let i = 0; i < couponList.length; i++) {
          let coupon = couponList[i];
          if(coupon.iCouponId){
            if(exitIds.length==0){
              exitIds += coupon.iCouponId;
            }else{
              exitIds += ","+coupon.iCouponId;
            }
          }
        }
        if (exitIds && exitIds.length > 0) {
          condition.simpleVOs.push({
            field: 'id',
            op: 'nin',
            value1: exitIds
          });
        }
        data.context.setFilter(condition);
      });

      viewmodel.get('iAreaId').on('afterValueChange', function (data) {
        common.displayArea(viewmodel);
        if (viewmodel.get('actityItemType').getValue() == 0) {
          delPro();
        }
      });

      viewmodel.get("iRange").on('afterValueChange', () => {
        displayiAreaId(viewmodel);
      })

      viewmodel.on('beforeEdit', function (args) {
        return common.checkAuth(viewmodel.originalParams.id, 'pmc_productcardcoupon');
      })
      viewmodel.on('afterEdit', function (data) {
        common.displayArea(viewmodel);
        common.displayChannel(viewmodel, 'pmc_productcardcoupon');
      })
      //保存前数据处理
      viewmodel.on('beforeSave', function (data) {

        var obj = JSON.parse(data.data.data);

        obj.terminalType = setCheckBoxEnum(obj.terminalType);

        if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
          if (!viewmodel.get("iAreaId").getValue() || viewmodel.get("iAreaId").getValue() == 0) {
            cb.utils.alert('请选择适用区域', 'warning');
            return false;
          }
        }

        if (this.get('applyOnlineChannel').getValue() == '1' && obj.terminalType == 0) {
          cb.utils.alert('适用线上商城时，适用终端不可为空', 'warning');
          return false;
        }

        if (this.get('bMemberLevelAll').getValue() == '0' && this.get('productCardCouponMemberL').getShowValue() == '') {
          cb.utils.alert('指定会员不可为空', 'warning');
          return false;
        } else if (this.get('bMemberLevelAll').getValue() != '0') {
          obj.productCardCouponMemberL = [];
        }


        if (this.get('pStartDate').getValue() >= this.get('pEndDate').getValue()) {
          cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
          return false;
        }
        if (viewmodel.get('productCardCouponPro').getRows() == '') {
          switch (obj.actityItemType) {
            case '0':
            case 0:
              cb.utils.alert('商品信息不能为空', 'warning');
              return false;
            case '1':
            case 1:
              cb.utils.alert('分类信息不能为空', 'warning');
              return false;
          }
        }else {
          for (var i = 0; i < viewmodel.get('productCardCouponPro').getRows().length; i++) {
            if (!viewmodel.get('productCardCouponPro').getRows()[i].lProductId) {
              switch (obj.actityItemType) {
                case '0':
                case 0:
                  cb.utils.alert('第' + (i + 1) + '行选择相应的商品信息', 'warning');
                  return false;
                case '1':
                case 1:
                  cb.utils.alert('第' + (i + 1) + '行选择相应的分类信息', 'warning');
                  return false;
              }
            }
          }
        }
        if (viewmodel.get('productCardCouponEntity').getRows() == '') {
          cb.utils.alert('优惠券信息不能为空', 'warning');
          return false;
        }else {
          for (var i = 0; i < viewmodel.get('productCardCouponEntity').getRows().length; i++) {
            if (!viewmodel.get('productCardCouponEntity').getRows()[i].iCouponId ) {
              cb.utils.alert('第' + (i + 1) + '行选择相应的优惠券信息', 'warning');
              return false;
            }
          }
        }



        data.data.data = JSON.stringify(obj);

      });
    }

  };
  try {
    module.exports = PM_pmc_productcardcoupon_VM_Extend;
  } catch (error) {
    console.log(error);
  }
  return PM_pmc_productcardcoupon_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_productcardcoupon_VM.Extend.js